import type { GridBlock } from "@juro/shared";

export function FormulaBar({
  block,
  selected,
  value,
  onChange,
}: {
  block: GridBlock;
  selected: { rowId: string; colId: string } | null;
  value: string;
  onChange: (value: string) => void;
}) {
  const label = selected
    ? `${block.id} / ${selected.rowId}.${selected.colId}`
    : "セルを選択してください";

  return (
    <div style={{ display: "grid", gridTemplateColumns: "170px 1fr", alignItems: "center", gap: 8 }}>
      <div style={{ fontSize: 12, color: "#64748b", fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
        {label}
      </div>
      <input
        value={value}
        disabled={!selected}
        onChange={(event) => onChange(event.target.value)}
        placeholder="= {row.qty} * {row.base}"
        style={{
          height: 34,
          border: "1px solid #cbd5e1",
          borderRadius: 7,
          padding: "0 11px",
          fontFamily: "Consolas, monospace",
          fontSize: 13,
          background: selected ? "#fff" : "#f8fafc",
          outline: "none",
        }}
      />
    </div>
  );
}
